<template>
  <v-card
    outlined
    class="mb-3"
    >
    <v-card-text
      class="d-flex justify-space-between align-center"
      >
      <div>
        {{ property.fullAddress }}
      </div>

      <div>
        <v-btn
          icon
          small
          @click="removeFromBuilding"
          >
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { RemovePropertyFromBuilding } from '@/graphql/mutations/buildings'

export default {
  props: {
    property: {
      type: Object,
      required: true
    }
  },

  methods: {
    removeFromBuilding () {
      this.$apollo.mutate({
        mutation: RemovePropertyFromBuilding,
        variables: {
          input: {
            id: this.property.id
          }
        }
      }).then ( res => {
        this.$emit('reload')
      })
    }
  }
}
</script>
